export default __webpack_public_path__ + "static/media/telegram icon.7a06dc42.svg";